import { supportConstants as sc } from 'srcReact/Pages/Support/constants'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { supportService } from '../../services/supportService'
import { alertActions } from 'srcReact/Alert'

export const supportActions = {
  getTickets,
  getTicketById,
  postTicket,
  updateTicket,
  clearData
}

function clearData() {
  return { type: sc.CLEAR_DATA }
}

function getTickets(orgId, offset, quantity = appConstantSettings.PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ orgId, offset, quantity }))

    supportService.getTickets(orgId, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.GET_TICKETS_REQUEST, response }
  }
  function success(response) {
    return { type: sc.GET_TICKETS_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_TICKETS_FAILURE, error }
  }
}

function getTicketById(orgId, ticketId) {
  return (dispatch) => {
    dispatch(request({ orgId, ticketId }))

    supportService.getTicketById(orgId, ticketId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: sc.GET_TICKET_BY_ID_REQUEST, response }
  }
  function success(response) {
    return { type: sc.GET_TICKET_BY_ID_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.GET_TICKET_BY_ID_FAILURE, error }
  }
}

function postTicket(form) {
  return (dispatch) => {
    dispatch(request(form))

    supportService.postTicket(form).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request(form) {
    return { type: sc.SUBMIT_CONTACT_REQUEST, form }
  }
  function success(response) {
    return { type: sc.SUBMIT_CONTACT_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.SUBMIT_CONTACT_FAILURE, error }
  }
}

function updateTicket(ticketId, action, message, fileIds) {
  return (dispatch) => {
    dispatch(request(ticketId, action, message, fileIds))

    supportService.updateTicket(ticketId, action, message, fileIds).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request(form) {
    return { type: sc.UPDATE_TICKET_REQUEST, form }
  }
  function success(response) {
    return { type: sc.UPDATE_TICKET_SUCCESS, response }
  }
  function failure(error) {
    return { type: sc.UPDATE_TICKET_FAILURE, error }
  }
}
